import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/star-icon.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-1aa4b50e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "complete-pathway-page"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "col-md-12 complete-page-message text-center" }, " Congratulations! Your team has completed: ", -1))
const _hoisted_3 = {
  key: 2,
  class: "col-md-12 outcome-title"
}
const _hoisted_4 = { class: "outcome-title-text" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "outcome-image-container" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = { class: "complete-pathway-details" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Pathway: ", -1))
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "pathway-benefits" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "benefits-title" }, "Benefits", -1))
const _hoisted_14 = { class: "benefits-list" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "bullet-point",
  class: "star-icon"
}, null, -1))
const _hoisted_16 = { class: "complete-instructions" }
const _hoisted_17 = { class: "button-container" }

import { debug as d } from "debug";
import axios from "axios";
import { computed, onBeforeMount, ref } from "vue";
import { useRoute } from "vue-router";
import { CmsDocumentTypes } from "../../services/cms/cms-type-configuration";
import cms from "../../services/cms/cms";
import { CmsGoalData, CmsTeamPathway } from "../../services/cms/cms-type-definitions";
import CompletePageModal from "../../components/team-outcomes/complete-page-modal.vue";
import LoadingPage from "../loading-page.vue";
import Confetti from "../../components/lottie-confetti.vue";
import { csContext } from "../../services/cs-context";
import {
  TeamMemberViewedCompletePageApiModel,
  TeamMemberCompletedPathwayStepApiModel,
  TeamPathwayApiModel,
} from "../../api-models";


export default /*#__PURE__*/_defineComponent({
  __name: 'complete-pathway',
  setup(__props) {

const debug = d("cs.CompletePathway");

const route = useRoute();

const isTeamLeader = ref(false);
const pathwayProgress = ref<TeamPathwayApiModel | null>(null);
const memberProgress = ref<TeamMemberCompletedPathwayStepApiModel | null>(null);
const pathway = ref<CmsTeamPathway | null>(null);
const outcome = ref<CmsGoalData | null>(null);
const outcomeId = ref("");
const teamId = ref("");
const isLoading = ref(true);
const showConfetti = ref(false);

const isTeamLeaderOrOrgAdmin = computed(
  () => isTeamLeader.value || csContext.userProfile.isOrgAdmin,
);
const buttonText = computed(() => (isTeamLeaderOrOrgAdmin.value ? "Complete Pathway" : "Continue"));
const instructions = computed(() => {
  const text = isTeamLeaderOrOrgAdmin.value
    ? `When you're ready, click the Pathway Complete button. Then choose a fresh Outcome or a different Pathway in this Outcome of '${cms.asText(
        outcome.value?.full_title,
      )}'.`
    : `Once your Team Lead has marked this Pathway as complete, choose a fresh Outcome or a different Pathway in this Outcome of '${cms.asText(
        outcome.value?.full_title,
      )}'.`;
  return `${text} See you in the next Pathway!`;
});

const completeModal = ref<InstanceType<typeof CompletePageModal> | null>(null);

async function completePathway(): Promise<void> {
  if (isTeamLeaderOrOrgAdmin.value) {
    completeModal.value?.openModal();
  } else {
    try {
      await axios.post("/api/TeamMemberCompletedPathway", {
        teamId: teamId.value,
        cmsPathwayId: pathway.value?.id,
      });
    } catch (e) {
      debug(e);
    } finally {
      window.location.href = `/home?view=TeamDashboard&team=${teamId.value}`;
    }
  }
}

async function getCurrentPathwayData(): Promise<void> {
  const response = await axios.get(`/api/TeamPathway/current/${teamId.value}`);
  const currentPathwayId = response.data;
  pathway.value = await cms.getById(CmsDocumentTypes.CmsTeamPathway, currentPathwayId);
  outcome.value = pathway.value.data.goal_relationship.data as CmsGoalData;
  const pathwayResponse = await axios.get(`/api/TeamPathway/${teamId.value}`);
  pathwayProgress.value = pathwayResponse.data.teamPathway;
  memberProgress.value = pathwayResponse.data.userProgress;
}

function toggleConfetti(): void {
  if (!showConfetti.value) {
    showConfetti.value = true;
    setTimeout(() => {
      showConfetti.value = false;
    }, 2000);
  }
}

async function hasViewedCompletePage(): Promise<void> {
  if (memberProgress.value && pathwayProgress.value?.completed) {
    const viewedPageModel: TeamMemberViewedCompletePageApiModel = {
      teamId: teamId.value,
      cmsStepId: memberProgress.value.cmsStepId,
      cmsPathwayId: memberProgress.value.cmsPathwayId,
      hasViewedCompletePage: true,
    };

    try {
      const response = await axios.patch("/api/TeamMemberCompletedPathwayStep", viewedPageModel);
      debug(response);
    } catch (e: any) {
      debug(e);
    }
  }
}

async function getTeamLeaderInfo(id: string): Promise<void> {
  const response = await axios.get(`/api/teamuserpermissions/${id}`);
  isTeamLeader.value = response.data.isLeader;
}

onBeforeMount(async () => {
  debug("PATHWAY");
  teamId.value = route.query.team?.toString() ?? "";
  await getCurrentPathwayData();
  await getTeamLeaderInfo(teamId.value);
  await hasViewedCompletePage();
  isLoading.value = false;
  toggleConfetti();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (!isLoading.value && pathway.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (showConfetti.value)
          ? (_openBlock(), _createBlock(Confetti, {
              key: 0,
              ref: "confetti"
            }, null, 512))
          : _createCommentVNode("", true),
        _createVNode(CompletePageModal, {
          teamId: teamId.value,
          pathwayId: pathway.value.id,
          ref_key: "completeModal",
          ref: completeModal
        }, null, 8, ["teamId", "pathwayId"]),
        (!pathwayProgress.value?.completed)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              to: _unref(cms).linkResolver(pathway.value),
              class: "back-button btn btn-default-back",
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Team Pathway ")
              ]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true),
        _hoisted_2,
        (outcome.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", {
                  class: "outcome-title-header",
                  innerHTML: _unref(cms).asHtml(outcome.value.full_title)
                }, null, 8, _hoisted_5),
                _createElementVNode("p", {
                  class: "outcome-title-desc",
                  innerHTML: _unref(cms).asHtml(outcome.value.brief_description)
                }, null, 8, _hoisted_6)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("img", {
                  src: outcome.value.image.url,
                  alt: _unref(cms).asText(outcome.value.name),
                  class: "outcome-image"
                }, null, 8, _hoisted_8)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("h2", null, [
            _hoisted_10,
            _createTextVNode(_toDisplayString(_unref(cms).asText(pathway.value.data.title)), 1)
          ]),
          _createElementVNode("p", {
            innerHTML: _unref(cms).asHtml(pathway.value.data.pathway_complete_content),
            class: "pathway-complete-text"
          }, null, 8, _hoisted_11),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("ul", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pathway.value.data.benefits, (benefit, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: `benefit` + index,
                  class: "benefit-item"
                }, [
                  _hoisted_15,
                  _createElementVNode("p", null, _toDisplayString(_unref(cms).asText(benefit.benefit_description)), 1)
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("p", null, _toDisplayString(instructions.value), 1)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: completePathway,
            "data-test": "complete-team-pathway-btn",
            type: "button"
          }, _toDisplayString(buttonText.value), 1),
          _createElementVNode("button", {
            class: "btn btn-default-celebrate",
            onClick: toggleConfetti,
            type: "button"
          }, " Celebrate! ")
        ])
      ]))
    : (_openBlock(), _createBlock(LoadingPage, { key: 1 }))
}
}

})